var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "posta-guvercini-detail" } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("message.details"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("message.manageChannelDetail"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { id: "new-sms-channel-form" } },
      [
        _c("a-form", [
          _c("div", { staticClass: "form-wrapper" }, [
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("name"),
                      help: _vm.getErrorMessage("name"),
                    },
                  },
                  [
                    _c("a-input", {
                      ref: "name",
                      attrs: {
                        placeholder: _vm.$t("whatsappChannel.channelName"),
                        name: "name",
                      },
                      model: {
                        value: _vm.clone.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "name", $$v)
                        },
                        expression: "clone.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.username")))]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("message.username"),
                    name: "username",
                  },
                  model: {
                    value: _vm.clone.payload.username,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "username", $$v)
                    },
                    expression: "clone.payload.username",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.password")))]),
                _vm._v(" "),
                _c("a-input-password", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("message.password"),
                    name: "password",
                  },
                  model: {
                    value: _vm.clone.payload.password,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "password", $$v)
                    },
                    expression: "clone.payload.password",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.yourCredit")))]),
                _vm._v(" "),
                _c("a-input", {
                  attrs: { value: String(_vm.credit), disabled: "" },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-footer" }, [
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "a-button",
                {
                  staticClass: "pr-confirm-btn",
                  attrs: { type: "primary", disabled: _vm.loading },
                  on: { click: _vm.handleSave },
                },
                [
                  _vm._v(
                    "\n                    " + _vm._s(_vm.$t("message.save"))
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }